import React, {PropTypes} from 'react';
import CustomList from '../../../../components/common/CustomList/CustomList'
import config from 'config';
import RaisedButton from 'material-ui/RaisedButton';
import {ListItemEditReduxForm} from './ListItemEditForm';
import {ListContentItem, ListItemImage} from '../../../../api/club-cms/content/list.content';
import {AListContentComponent} from '../AbstractListComponent';
import SimpleReactSortableComponent from '../../DragItems/DraggableItem/SimpleReactSortableComponent';
import EngineerItem from '../../DragItems/DraggableItem/EngineerItem';

export class ListContentComponent extends AListContentComponent {
  static contextTypes = {
    muiTheme: PropTypes.object.isRequired
  };

  createNewItem(data) {
    return new ListContentItem({
      ...data,
      details: data.details.toParams()
    });
  }

  deleteItem = this.deleteItem.bind(this);
  editItem = this.displayEditProfile.bind(this);
  moveItem = this.moveItem.bind(this);
  renderOverlay = this.renderOverlay.bind(this);
  getThemeColor = this.getThemeColor.bind(this);

  moveItem(dragIndex, hoverIndex) {
    const {node, onChange} = this.props;
    onChange(node.move(dragIndex, hoverIndex));
  }

  getThemeColor(){
    const {secondaryTextColor} = this.context.muiTheme.flatButton;
    return secondaryTextColor;
  }

  renderOverlay() {
    return (
      <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          height: '100%',
          width: '100%',
          zIndex: 1,
          opacity: 0.3,
          backgroundColor: this.getThemeColor()
        }}/>
    );
  }

  render() {
    const {open, editInitialValues}  = this.state;
    const {node = {items: []}} = this.props;

    return (
      <div>
        {node.items.map((item, index) => (
          <CustomList
            cellHeight={180}
            cols={1}
            padding={0}
            children={
              <div key={index}>
                <SimpleReactSortableComponent
                  index={index}
                  node={item}
                  moveItem={this.moveItem}
                  renderOverlay={this.renderOverlay}>
                  <EngineerItem
                    item={item}
                    index={index}
                    id={index}
                    editItem={this.editItem}
                    deleteItem={this.deleteItem}
                    color={this.getThemeColor()}/>
                </SimpleReactSortableComponent>
              </div>}/>
        ))}
        <div style={{padding: 30}}>
          <RaisedButton secondary label="Add new person" onClick={() => this.showAdd()}/>
        </div>
        <ListItemEditReduxForm open={open}
                               ImageClass={ListItemImage}
                               imageCrop={config.clubCms.listCrop}
                               initialValues={editInitialValues}
                               onSave={(data) => this.saveProfile(data)}
                               onClose={() => this.closeEditProfile()}
        />
      </div>
    );
  }
}

export default ListContentComponent;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/ListContentComponent/ListContentComponent.js